import React from 'react';
import { Button, Checkbox, Col, Radio, Row } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { RadioChangeEvent } from 'antd/es/radio';
import timeFormat from '../../utils/timeFormat';
import type { TestAnswersMap, TestQuestion, TestType } from './types';

interface TestPassageProps {
  testType?: TestType;
  timer: number;
  title: string;
  currentQuestionNum: number;
  questionsLength: number;
  currentQuestion: TestQuestion;
  questionIds: number[];
  answers: TestAnswersMap;
  onNext: () => void;
  onRadioChange: (e: RadioChangeEvent) => void;
  onSelectChange: (e: CheckboxChangeEvent) => void;
}

const TestPassage: React.FC<TestPassageProps> = ({
  testType = 'default',
  timer,
  title,
  currentQuestionNum,
  questionsLength,
  currentQuestion,
  questionIds,
  answers,
  onNext,
  onRadioChange,
  onSelectChange,
}) => {

  return (
    <>
      <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
        <Col span={24}>
          <div style={{ fontWeight: 600, fontSize: 25, position: 'absolute' }}>{timeFormat(timer)}</div>
          <div style={{ width: '100%' }}>
            <div style={{ fontSize: 25, textAlign: 'center', width: '65%', margin: 'auto' }}>{title}</div>
          </div>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 30, marginBottom: 30 }}>
        <Col xs={24} sm={24} md={24} lg={16} xl={18} xxl={19} style={{ fontSize: 20 }}>
          <div style={{ marginBottom: 10 }}>Вопрос {currentQuestionNum + 1}:</div>
          <div style={{ fontSize: 14, color: '#A40207', marginBottom: 30 }}>
            {currentQuestion.rightAnswersCount === 1 ? 'Ответ может быть один' : 'Ответов может быть несколько'}
          </div>
          <div style={{ fontWeight: 600, marginBottom: 6 }}>
            <span>{currentQuestion.text}</span>
          </div>
          {testType === 'monthly' && (
            <div style={{ marginBottom: 20 }}>
              <span
                style={{
                  display: 'inline-block',
                  fontSize: 12,
                  lineHeight: '18px',
                  padding: '2px 10px',
                  borderRadius: 999,
                  backgroundColor: '#A40207',
                  color: '#fff',
                  whiteSpace: 'nowrap',
                }}
              >
                {currentQuestion.material?.category?.name || currentQuestion.category?.name || currentQuestion.material?.name || ''}
              </span>
            </div>
          )}
          <div style={{ fontSize: 18, marginBottom: 5 }}>
            {currentQuestion.rightAnswersCount === 1 ? (
              <Radio.Group onChange={onRadioChange}>
                {currentQuestion.answers.map((answer) => (
                  <div key={answer.id} style={{ marginBottom: 20 }}>
                    <Radio style={{ fontSize: 18 }} value={answer.id}>
                      {answer.text}
                    </Radio>
                  </div>
                ))}
              </Radio.Group>
            ) : (
              currentQuestion.answers.map((answer) => (
                <div key={answer.id} style={{ marginBottom: 20 }}>
                  <Checkbox onChange={onSelectChange} value={answer.id} /> {answer.text}
                </div>
              ))
            )}
          </div>
          <Button className="pale" onClick={onNext}>
            {currentQuestionNum === questionsLength - 1 ? 'Завершить' : 'Далее'}
          </Button>
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={6} xxl={5}>
          <Row gutter={[16, 16]}>
            {questionIds.map((questionId, i) => {
              const hasAnswer = Boolean(answers[questionId]?.length);
              const borderColor = i === currentQuestionNum ? '#A40207' : hasAnswer ? '#F7D5D6' : '';
              const backgroundColor = i !== currentQuestionNum && hasAnswer ? '#F7D5D6' : '';
              return (
                <Col key={questionId} xs={4} sm={4} md={8} lg={8} xl={8}>
                  <div style={{ border: `${borderColor} 1px solid`, textAlign: 'center', padding: 10, fontSize: 16, backgroundColor }}>
                    {i + 1}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default TestPassage;
